import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({ providedIn: 'root' })
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private readonly appConfigService: AppConfigService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const appConfig = this.appConfigService.getConfig();
    if (appConfig?.posApiKey) {
      const encodedToken = btoa(`api:${appConfig.posApiKey}`);
      request = request.clone({
        setHeaders: {
          Authorization: `Basic ${encodedToken}`
        }
      });
    }
    return next.handle(request);
  }
}
